module.exports = __webpack_public_path__ + "static/media/kamva.f4673b56.jpeg";